import { createFrontendModule } from '@backstage/frontend-plugin-api';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { IconBundleBlueprint } from '@backstage/plugin-app-react';
import { SidebarContent } from './Sidebar';
import CustomerIcon from '@material-ui/icons/People';
import EnvironmentIcon from '@material-ui/icons/AccountTree';

export const CustomerIconBundle: ExtensionDefinition = IconBundleBlueprint.make({
  name: 'customer-icons',
  params: {
    icons: {
      'kind:customer': CustomerIcon,
      'kind:environment': EnvironmentIcon,
    },
  },
});

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent, CustomerIconBundle],
});
